"use strict";

/* TO DO:
    - stop dropdown from showing when address field is asl;gkjasfgl;jadsfaagas
*/

const $ = jQuery;

module.exports = class {

	#cache = new Map();
    #searchTerm = '';

	config = {
        id: null,
		matchingAjax: {
			url: `${window.location.origin}/wp-json/lumeris/v1/melissa/express-address`,
			method: 'GET'
		},
		delay: 500,
        minimumLength: 3,
		optionsCallback: null,
        cache: true,
        cacheLimit: 20
	};

	$form;
    $streetAddressField;
    $streetAddress2Field;
    $cityField;
    $countyField;
    $stateField;
	$zipCodeField;
    $resultCodeField;
	$dropdown;
	$list;

	constructor(args) {
		this.$form = args.$form ?? null;

		if (!this.$form || this.$form.length === 0) {
			return null;
		}

        this.config.id = args.id ?? null;

		this.$streetAddressField = args.$streetAddressField ?? null;
		this.$streetAddress2Field = args.$streetAddress2Field ?? null;
		this.$cityField = args.$cityField ?? null;
        this.$countyField = args.$countyField ?? null;
		this.$stateField = args.$stateField ?? null;
		this.$zipCodeField = args.$zipCodeField ?? null;
        this.$resultCodeField = args.$resultCodeField ?? null;

		this.$dropdown = args.$dropdown ?? $('<div class="melissa-express-address-dropdown"></div>');
		this.$list = args.$list ?? $('<ul class="melissa-express-address-list"></ul>');

		if (typeof args.$list == 'undefined') {
			this.$dropdown.append(this.$list);
		}

        this.$form.trigger('melissa-express-address:insert-dropdown', {
            $dropdown:  this.$dropdown
        });

        this.$form.trigger(`melissa-express-address:insert-dropdown:${this.config.id}`, {
            $dropdown:  this.$dropdown
        });

		this.bind();
	}


	bind() {
        $('body').on('click', (event) => { this.onBodyClick(event); });

		if (this.$streetAddressField) {
            this.$streetAddressField.on('input', (event) => { this.onStreetAddressInput(event); });
            this.$streetAddressField.on('focus', (event) => { this.onStreetAddressFocus(event); });
            this.$streetAddressField.on('keypress', (event) => { this.onStreetAddressKeypress(event); });
            this.$streetAddressField.on('change', (event) => { this.onStreetAddressChange(event); });
        }

        if (this.$streetAddress2Field) {
            this.$streetAddress2Field.on('change', (event) => { this.onStreetAddress2Change(event); });
        }

        if (this.$cityField) {
            this.$cityField.on('change', (event) => { this.onCityChange(event); });
        }

        if (this.$stateField) {
            this.$stateField.on('change', (event) => { this.onStateChange(event); });
        }

        if (this.$zipCodeField) {
            this.$zipCodeField.on('change', (event) => { this.onZipCodeChange(event); });
        }
	}

	bindListOptions() {
        this.$list.find('a').on('click', (event) => { this.onListOptionClick(event); });
    }

	get searchTerm() {
        return this.#searchTerm;
    }

    get cache() {
        return this.#cache;
    }

	getCache(key) {
        return this.cache.get(key) || null;
    }

    getCacheKey(args) {
        const isSecondAttempt = args.isSecondAttempt ?? false;

        const streetAddress = (this.$streetAddressField) ? (this.$streetAddressField.val() ?? '').toLowerCase() : '';
        const streetAddress2 = (!isSecondAttempt && this.$streetAddress2Field) ? (this.$streetAddress2Field.val() ?? '').toLowerCase() : '';
        const city = (!isSecondAttempt && this.$cityField) ? (this.$cityField.val() ?? '').toLowerCase() : '';
        const state = (!isSecondAttempt && this.$stateField) ? (this.$stateField.val() ?? '').toLowerCase() : '';
        const zipCode = (!isSecondAttempt && this.$zipCodeField) ? this.$zipCodeField.val() : '';
        
        return `c-${streetAddress}-${streetAddress2}-${city}-${state}-${zipCode}`;
    }

    getNoResultsOption() {
        return '<li role="option" aria-selected="false"><span>No matching addresses were found.</span></li>';
    }

    getParams() {
        const params = {};

        if (this.$streetAddressField) {
            params.streetAddress =  this.$streetAddressField.val() ?? '';
        }
        
        if (this.$streetAddress2Field) {
            params.streetAddress2 = this.$streetAddress2Field.val() ?? '';
        }

        if (this.$cityField) {
            params.city =  this.$cityField.val() ?? '';
        }

        if (this.$stateField) {
            params.state = this.$stateField.val() ?? '';
        }

        if (this.$zipCodeField) {
            params.zipCode = this.$zipCodeField.val() ?? '';
        }

        return params;
    }

    async getResults(args) {
        if (!args || !args.params) {
            return null;
        }

        const cacheKey = this.getCacheKey(args);
        const cachedData = this.getCache(cacheKey);
        
        if (cachedData) {
            return cachedData;
        }
        
        const url = new URL(this.config.matchingAjax.url);
        url.search = new URLSearchParams(args.params).toString();

        try {
            const response = await fetch(url, {
                method: this.config.matchingAjax.method,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                cache: 'no-cache'
            });
        
            const json = await response.json();

            if (json.http_code == 200) {
                this.setCache(cacheKey, json);
            }

            return json;
        } catch (error) {
            console.error(error);
            return [];
        }
    }

	getMatches(args={}) {
        const params = args.params ?? {
            streetAddress: null,
            streetAddress2: null,
            city: null,
            state: null,
            zipCode: null
        };
        const backgroundMode = args.backgroundMode ?? false;
        const isSecondAttempt = args.isSecondAttempt ?? false;

        clearTimeout(this.timeout);
        this.searchTerm = params.streetAddress;

        if (!this.validateTerm(params.streetAddress)) {
            this.hideDropdown();
            this.clearResults();
            return null;
        }

        this.timeout = setTimeout(() => {
            requestAnimationFrame(() => {

                if (!backgroundMode) {
                    this.showSearching();
                }

                return this.doSearch(args).then((optionsData) => {
					if (optionsData.http_code == '200') {
                        if (!this.hasResults(optionsData.results) && !isSecondAttempt) {
                            return this.getMatches({
                                params: { 'streetAddress': params.streetAddress },
                                isSecondAttempt: true, 
                                backgroundMode: backgroundMode 
                            });
                        }
                        
                        if (this.searchTerm === params.streetAddress && this.validateResults(optionsData.results)) {
							this.updateResults({ params: params, data: optionsData.results });
						}
                        
						this.hideSearching();

                        if (!backgroundMode && this.hasResults(optionsData.results)) {
						    this.showDropdown();
                        }
					}
                }); 
            });
        }, this.config.delay);
    }

    set searchTerm(val) {
        this.#searchTerm = val;
        this.$form.trigger('melissa-express-address:updated-search-term', {searchTerm: val});
        this.$form.trigger(`melissa-express-address:updated-search-term:${this.config.id}`, {searchTerm: val});
    }

    setCache(key, value) {
        if (key && value !== undefined) {
            this.cache.set(key, value);

            if (this.cache.size > this.config.cacheLimit) {
                this.cache.delete(this.cache.keys()[0]);
            }
        }
    }

    hasResults(data) {
        return (!data || data.length == 0 || typeof data.Results == 'undefined' || data.Results.length == 0) ? false : true;
    }

	updateResults(args) {
        const optionsData = args.data ?? null;
        
        this.clearResults();

        if (!this.hasResults(optionsData)) {
            // this.$list.append(this.getNoResultsOption());
            this.hideDropdown();
        } else {
            const options = optionsData.Results.map((option) => {
                option.ResultCode = optionsData.ResultCode;
                
                if (option.Address.AddressKey.indexOf(',') !== -1) {
                    option.Address.AddressKey = option.Address.AddressKey.split(',');
                }

                let html = `<li role="option" aria-selected="false"><a href="#" data-value="${encodeURIComponent(JSON.stringify(option))}">${option.Address.AddressLine1}, ${option.Address.City}, ${option.Address.State} ${option.Address.PostalCode}</a></li>`;

                if (option.Address.SuiteCount > 1 && option.Address.SuiteList && option.Address.SuiteList.length > 0) {
                    let suiteOptionsHtml = option.Address.SuiteList.map((suite, i) => {
                        let suiteOption = JSON.parse(JSON.stringify(option));
                        suiteOption.Address.AddressLine1 = `${suiteOption.Address.AddressLine1} ${suite}`;
                        suiteOption.Address.AddressKey = suiteOption.Address.AddressKey[i];
                        return `<li role="option" aria-selected="false"><a href="#" data-value="${encodeURIComponent(JSON.stringify(suiteOption))}">${suiteOption.Address.AddressLine1}, ${suiteOption.Address.City}, ${suiteOption.Address.State} ${suiteOption.Address.PostalCode}</a></li>`;
                    });
                    
                    html += suiteOptionsHtml.join('');
                }
                return html;
            }).join('');
          
            this.$list.append(options);
            this.bindListOptions();
        }

        this.$form.trigger('melissa-express-address:updated-results', {
            term: this.searchTerm, 
            data: optionsData
        });

        this.$form.trigger(`melissa-express-address:updated-results:${this.config.id}`, {
            term: this.searchTerm, 
            data: optionsData
        });
    }

    validateResults(optionsData) {
        if (!(optionsData.ResultCode ?? null)) {
            return false;
        }
        const category = optionsData.ResultCode.substring(0, 2);
        
        if (['AE', 'GE', 'SE'].indexOf(category) !== -1) {
            this.$form.trigger('melissa-express-address:result-code-error', {
                term: this.searchTerm, 
                data: optionsData
            });
    
            this.$form.trigger(`melissa-express-address:result-code-error:${this.config.id}`, {
                term: this.searchTerm, 
                data: optionsData
            });

            return false;
        }

        return true;
    }

    validateTerm(term) {
        if (!(new RegExp("^[0-9]*[a-z ]{" + this.config.minimumLength + "}", 'i').test(term))) {
            return false;
        }

        return true;
    }

    async doSearch(args) {
        if (!args || !args.params) {
            return null;
        }

        const data = await this.getResults(args);
        return (typeof this.config.optionsCallback === 'function') ? this.config.optionsCallback(data, this.config) : data;
    }

    filterValue(value) {
        return value.trimStart();
    }   

    filterStreetAddressField() {
        this.$streetAddressField.val(this.filterValue(this.$streetAddressField.val()));
    }

	showSearching() {
        this.$form.addClass('is-melissa-express-address-searching');
    }

    hideSearching() {
        this.$form.removeClass('is-melissa-express-address-searching');
    }

    showDropdown() {
        this.$streetAddressField.attr('aria-expanded', 'true');
		this.$dropdown.addClass('is-showing');
    }

    hideDropdown() {
        this.$streetAddressField.attr('aria-expanded', 'false');
		this.$dropdown.removeClass('is-showing');
    }

    clearResults() {
        this.$list.html('');
    }

    clearCounty() {
        this.$countyField.val('');
    }

    clearResultCode() {
        this.$resultCodeField.val('');
    }

	on(event, callback) {
        return this.$form.on(event, callback);
    }

    onBodyClick(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }

        if (!this.$streetAddressField.parent().is(event.target) && !this.$streetAddressField.parent().has(event.target).length) {
            this.hideDropdown();
        }
    }

    onStreetAddressInput(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }
        this.filterStreetAddressField();
        this.getMatches({ params: this.getParams() });
    }

    onStreetAddressKeypress(event) {
        if (!(event.originalEvent instanceof Event) || event.keyCode !== 13) {
            return null;
        }

        this.filterStreetAddressField();
        this.getMatches({ params: this.getParams() });
    }

    onStreetAddressFocus(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'focus' }}));

        if (this.$list.find('li').length !== 0) {
            this.showDropdown();
        }
    }

    onStreetAddressChange(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }
        
        this.clearCounty();
        this.clearResultCode();
        this.filterStreetAddressField();
        this.getMatches({ params: this.getParams(), backgroundMode: true });
    }

    onStreetAddress2Change(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }

        this.clearResultCode();
        this.getMatches({ params: this.getParams(), backgroundMode: true });
    }

    onCityChange(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }
        this.clearResultCode();
        this.getMatches({ params: this.getParams(), backgroundMode: true });
    }

    onStateChange(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }
        this.clearCounty();
        this.clearResultCode();
        this.getMatches({ params: this.getParams(), backgroundMode: true });
    }

    onZipCodeChange(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }

        this.clearCounty();
        this.clearResultCode();
        this.getMatches({ params: this.getParams(), backgroundMode: true });
    }

	async onListOptionClick(event) {
        if (!(event.originalEvent instanceof Event)) {
            return null;
        }

        event.preventDefault();

        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'select' }}));

		this.hideDropdown();

        const $target = $(event.target);

        try {
            const data = JSON.parse(decodeURIComponent($target.attr('data-value')));

            this.$form.trigger('melissa-express-address:selected-address', {data: data});
            this.$form.trigger(`melissa-express-address:selected-address:${this.config.id}`, {data: data});

            this.clearResults();

            this.$streetAddressField.val(data.Address.AddressLine1 ?? '');
            this.$cityField.val(data.Address.City);
            this.$countyField.val(data.Address.Extras.CountyName);
            this.$stateField.val(data.Address.State);
            this.$zipCodeField.val(data.Address.PostalCode.substring(0, 5));
            this.$resultCodeField.val(data.ResultCode);
        } catch (error) {
            console.error(error);
        }
    }

}